import axios from "axios";
import React, { useRef, useState } from "react";
import { ChromePicker } from 'react-color';

const ProductVariationForm = (props) => {
  const token = localStorage.getItem("token");
  const {
    state,
    setShowModal,
    isOpen,
    selectedItem,
    setSelectedItem,
    orderList,
    setOrderList,
    // variationData,
    // seteVariationData,
    formId,
    type,
    billType,
    typePurchase,
    typeSaleEdit,
    orderIndex,
    handleSelectedFoodPrice,
  } = props;

  const variationForm = {
    product_id: "",
    name: "",
    serial: "",
    purchase_price: "",
    wholesale_price: "",
    retails_price: "",
    discount_type: 0,
    quantity: 1,
  };
  const quantity = selectedItem.qty;
  // const initialVariationData = Array.from({ length: selectedItem.qty }, () => ({ ...variationForm }));
  // const [variationData, seteVariationData] = useState(initialVariationData);
  const [variationData, seteVariationData] = useState(
    selectedItem.variants
      ? selectedItem.variants
      : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
      ? orderList
      : ""
  );

  console.log("selected Item 1111111111111", selectedItem);
  console.log("ORDER LISTTTTT 1111111111111", orderList);

  // console.log(variationData);
  const [currentPos, setCurrentPos] = useState(0);
  const [isForEcommerce, setIsForEcommerce] = useState(false);

  const checkImeiDuplicity = async (imei) => {
    // console.log("Checking IMEI:", imei);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}check-product-imei`,
        { imei },
        {
          headers: {
            authorization: `Bearer ${token}`, // Replace with your token or state reference
            "Content-Type": "application/json",
          },
        }
      );
      return response.data.available; // Returns true if IMEI is available, false otherwise
    } catch (error) {
      console.error("Error checking IMEI duplicity:", error);
      return false; // Treat as unavailable in case of an error
    }
  };

  const handleNext = async () => {
    try {
      if (variationData[currentPos]?.serial === "") {
        setShowError(true);
        return;
      }
      // console.log("IMEI being checked:", variationData[currentPos]?.serial);

      if (!typePurchase || !selectedItem?.onExchange) {
        const isAvailable = await checkImeiDuplicity(
          variationData[currentPos]?.serial
        );
        if (!isAvailable) {
          alert("IMEI already exists. Please use a different IMEI.");
          return;
        }
      }

      setCurrentPos(currentPos + 1);
    } catch (error) {
      console.error("Error in handleNext:", error);
    }
  };

  const handleSubmit = async (e) => {
    console.log("billType: ", billType);
    e.preventDefault();
    if ((!typePurchase || !selectedItem?.onExchange)  && variationData[currentPos]?.serial === "") {
      setShowError(true);
      return;
    }
    if (((!typePurchase || !selectedItem?.onExchange) && !typeSaleEdit)) {
      const isAvailable = await checkImeiDuplicity(
        variationData[currentPos]?.serial
      );
      if (!isAvailable) {
        alert("IMEI already exists. Please use a different IMEI.");
        return;
      }
    }

    setShowModal(false);
    const existingIndex = orderList.findIndex(
      (orderItem) => orderItem?.id === selectedItem?.id
    );
    console.log("variationData ", variationData);
    // const total = variationData.reduce(
    //   (s, item) =>
    //     (s += Number.parseFloat(
    //       typePurchase
    //         ? item.product_imei[0].purchase_price
    //         : item.purchase_price
    //     )),
    //   0
    // );
    const total = variationData.reduce((s, item) => {
      const price = Number.parseFloat(
        (typePurchase || selectedItem?.onExchange) && typeSaleEdit
          ? item.product_imei?.[0]?.purchase_price ?? 0
          : item.purchase_price ?? 0
      );
      return s + price;
    }, 0);
    console.log("total sum", total);
    const updatedOrderList = [...orderList];
    console.log("Existing Index ..... ", existingIndex)
    if (orderIndex !== -1 && (typePurchase || selectedItem?.onExchange && typeSaleEdit) ) {
      if (
        updatedOrderList[orderIndex] &&
        updatedOrderList[orderIndex].product_imei &&
        variationData[orderIndex] &&
        variationData[orderIndex].product_imei
      ) {
        updatedOrderList[orderIndex].product_imei[0] = variationData[orderIndex].product_imei[0];
      }
    }
    if((typePurchase || selectedItem?.onExchange) && typeSaleEdit){
      updatedOrderList[orderIndex].variants = variationData;
    }else{
      updatedOrderList[existingIndex].variants = variationData;
    }
    if(updatedOrderList[existingIndex].onExchange){
      if(updatedOrderList[existingIndex].variants){
        updatedOrderList[existingIndex].purchase_price = updatedOrderList[existingIndex].variants[0].purchase_price;
      }
    }

    updatedOrderList[existingIndex].variantsSum = 1;
    console.log("Updated Order List:", updatedOrderList);
    setOrderList(updatedOrderList);
  };

  // const handleSubmit = (e) =>{
  //   e.preventDefault();
  //   if(variationData[currentPos].serial=="") {
  //     setShowError(true);
  //     return;
  //   }
  //   setShowModal(false);
  //   const existingIndex = orderList.findIndex(
  //     (orderItem) => orderItem?.id === selectedItem?.id
  //   );
  //   const total = variationData.reduce((s, item)=> s += Number.parseFloat(item.purchase_price), 0)
  //   console.log("total sum", total);
  //   const updatedOrderList = [...orderList];
  //   updatedOrderList[existingIndex].variants = variationData;
  //   updatedOrderList[existingIndex].variantsSum = 1;
  //   // updatedOrderList[existingIndex].purchase_price = total;
  //   console.log('update OrderLIst ',updatedOrderList);
  //   setOrderList(updatedOrderList);
  // }

  // const handleNext = async () => {
  //   if (variationData[currentPos].serial == "") {
  //     setShowError(true);
  //     return;
  //   }
  //   const isAvailable = await checkImeiDuplicity(
  //     variationData[currentPos].serial
  //   );
  //   if (!isAvailable) {
  //     alert("IMEI already exists. Please use a different IMEI.");
  //     return;
  //   }
  //   setCurrentPos(currentPos + 1);
  // };

  const handleBack = () => {
    if (currentPos < 1) return;
    setCurrentPos(currentPos - 1);
  };

  const [showError, setShowError] = useState(false);
  const [color, setColor] = useState(
                  ((typePurchase || selectedItem?.onExchange) && typeSaleEdit )
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0]?.color_code ?? "ffff"
                    : variationData[currentPos]?.color_code
                    ? variationData[currentPos]?.color_code : "ffff"
                );

  const handleChange = (color) => {
    setColor(color.hex);

    let updatedVariationData;
    console.log("color.hex... ", color.hex);

    if ((typePurchase || selectedItem?.onExchange && typeSaleEdit)) {
      updatedVariationData = variationData?.map((item, index) => {
        if (index === orderIndex) {
          return {
            ...item,
            product_imei: item.product_imei?.map((imei, i) =>
              i === 0 ? { ...imei, color_code: color.hex } : imei
            ),
          };
        }
        return item;
      });
    } else {
      updatedVariationData = variationData?.map((item, index) =>
        index === currentPos
          ? { ...item, color_code: color.hex }
          : item
      );
    }

    seteVariationData(updatedVariationData);
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    setColor(e.target.value);
    let updatedVariationData;

    if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
      updatedVariationData = variationData?.map((item, index) => {
        if (index === orderIndex) {
          return {
            ...item,
            product_imei: item.product_imei?.map((imei, i) =>
              i === 0
                ? { ...imei, color_code: e.target.value }
                : imei
            ),
          };
        }
        return item;
      });
    } else {
      updatedVariationData = variationData?.map((item, index) => {
        return index === currentPos
          ? { ...item, color_code: e.target.value }
          : item;
      });
    }

    seteVariationData(updatedVariationData);
  };

  const resolveColor = () => {
    let code;

    if ((typePurchase || selectedItem?.onExchange)  && typeSaleEdit) {
      code = variationData?.[orderIndex]?.product_imei?.[0]?.color_code;
    } else {
      code = variationData?.[currentPos]?.color_code;
    }

    return code || "#ffff"; // fallback to white
  };

  return (
    <div className="">
      {/* {console.log("selected item ", selectedItem)} */}
      <div className="w-full max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between gap-6">
            <h1 className="text-md text-left font-semibold mb-[8px]">
              Variation {(typePurchase || selectedItem?.onExchange) && typeSaleEdit ? orderIndex + 1 : currentPos + 1}
            </h1>
            {Number(typePurchase ? orderList.length : selectedItem.qty) > 1 ? (
              <div className="flex items-center justify-center py-1 gap-3 w-80">
                <div className="w-full relative p-2">
                  <button
                    onClick={handleBack}
                    className="cursor-pointer w-full border-2 border-[#034AFF] py-[11px] hover:bg-[#034AFF] hover:text-[#fff] text-center rounded-2xl text-[#034AFF] font-semibold text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[#034AFF] focus-visible:ring-offset-2"
                  >
                    Back
                  </button>
                </div>
                <div className="w-full relative">
                  {currentPos + 1 != quantity ? (
                    <button
                      onClick={handleNext}
                      className="cursor-pointer w-full bg-[#034AFF] py-[13px] text-center rounded-2xl text-[#fff] font-semibold text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[#034AFF] focus-visible:ring-offset-2"
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      htmlFor={formId}
                      tabIndex={0}
                      onClick={handleSubmit}
                      className="cursor-pointer w-full bg-[#034AFF] py-[13px] text-center rounded-2xl text-[#fff] font-semibold text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[#034AFF] focus-visible:ring-offset-2"
                    >
                      Done
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center py-1 gap-3 w-80">
                <div className="w-full relative p-2">
                  {currentPos + 1 != quantity ? (
                    <button
                      onClick={handleNext}
                      className="cursor-pointer w-full bg-[#034AFF] py-[13px] text-center rounded-2xl text-[#fff] font-semibold text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[#034AFF] focus-visible:ring-offset-2"
                    >
                      Next
                    </button>
                  ) : (
                    <button
                      htmlFor={formId}
                      tabIndex={0}
                      onClick={handleSubmit}
                      className="cursor-pointer w-full bg-[#034AFF] py-[13px] text-center rounded-2xl text-[#fff] font-semibold text-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[#034AFF] focus-visible:ring-offset-2"
                    >
                      Done
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 py-3">
            {/* box 1 */}

            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Region
              </label>
              <input
                type="text"
                name="name"
                placeholder="Region"
                value={
                  (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData?.[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0]?.region
                    : variationData[currentPos]?.region
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0 ? { ...imei, region: e.target.value } : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, region: e.target.value }
                        : item;
                    });
                  }

                  if (updatedVariationData) {
                    seteVariationData(updatedVariationData);
                  }
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                SL/IMEI *
              </label>
              <input
                type="text"
                name="name"
                placeholder="Ex: 12345"
                value={
                  variationData[currentPos]?.serial
                    ? variationData[currentPos]?.serial
                    : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].imei
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0 ? { ...imei, imei: e.target.value } : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, serial: e.target.value }
                        : item;
                    });
                  }

                  if (updatedVariationData) {
                    seteVariationData(updatedVariationData);
                    setShowError(false);
                  }
                }}
                className={`input input-bordered border-2 ${
                  showError ? "border-red-500" : "border-gray-500"
                }  w-full mb-[10px] rounded-xl bg-white`}
              />
              {/* {showError
            ? <p className="error-message text-red-500 mb-3 pl-1">This field cannot be empty.</p>
            : null} */}
            </div>

            {/* box 2 */}

            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Purchase Price
              </label>
              {console.log("currentpos purchase... ",variationData[currentPos]?.purchase_price)}
              {console.log("typePurchase.... ",typePurchase)}
              {console.log("orderIndex.... ",orderIndex)}
              {console.log("currentpos.... ",currentPos)}
              {console.log("selectedItem?.onExchange.... ",selectedItem?.onExchange)}
              {console.log("billType: ", billType)}
              {/* {console.log("Purchase Price.... ",variationData[typePurchase ? orderIndex : currentPos]
                        ?.product_imei[0]?.purchase_price)} */}
              <input
                type="text"
                name="name"
                placeholder="0.00"
                value={
                  (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData[(typePurchase || selectedItem?.onExchange) && typeSaleEdit ? orderIndex : currentPos]
                        ?.product_imei[0]?.purchase_price
                    : variationData[currentPos]?.purchase_price
                    ? variationData[currentPos]?.purchase_price : ""
                }
                onChange={(e) => {
                  let updatedVariationData;
                  console.log("onchange typePurchase........ ", typePurchase)
                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      console.log("onchange item ", item)
                      console.log("onchange index ", index)
                      if (index === orderIndex) {
                        console.log("check.... ", item.product_imei?.map((imei, i) =>
                          i === 0
                            ? { ...imei, purchase_price: e.target.value }
                            : imei
                        ))
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, purchase_price: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                    console.log("updated Var.... ", updatedVariationData[orderIndex])
                    console.log("orderList.... ", orderList[orderIndex])
                    handleSelectedFoodPrice(
                      updatedVariationData[orderIndex],
                      e.target.value,
                      orderIndex
                    );
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, purchase_price: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData([...updatedVariationData]);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Wholesale Price
              </label>
              <input
                type="text"
                name="name"
                placeholder="0.00"
                value={
                  variationData[currentPos]?.wholesale_price
                    ? variationData[currentPos]?.wholesale_price
                    : (typePurchase || selectedItem?.onExchange)
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].wholesale_price
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, wholesale_price: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, wholesale_price: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>

            {/* box 3 */}

            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Sale Price
              </label>
              <input
                type="text"
                name="name"
                placeholder="0.00"
                value={
                  variationData[currentPos]?.retails_price
                    ? variationData[currentPos]?.retails_price
                    : (typePurchase || selectedItem?.onExchange && typeSaleEdit)
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].sale_price
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if (typePurchase) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, retails_price: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, retails_price: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                QTY
              </label>
              <input
                type="text"
                name="name"
                // disabled
                placeholder="0.00"
                value={
                  variationData[currentPos]?.quantity
                    ? variationData[currentPos]?.quantity
                    : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? 1
                    : ""
                }
                // onChange={(e)=>setCurrentVarient({...currentVarient, variationQty: e.target.value})}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>

            {/* box 3 */}

            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Color
              </label>
              <input
                type="text"
                name="color"
                placeholder="Color"
                value={
                  variationData[currentPos]?.color
                    ? variationData[currentPos]?.color
                    : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].color
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0 ? { ...imei, color: e.target.value } : imei
                          ),
                        };
                      }
                      return item;
                    });
                    console.log("updated Var COLOR.... ", updatedVariationData[orderIndex])
                    console.log("orderList COLOR.... ", orderList[orderIndex])
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, color: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Storage
              </label>
              <input
                type="text"
                name="name"
                placeholder="Storage"
                value={
                  variationData[currentPos]?.storage
                    ? variationData[currentPos]?.storage
                    : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].storage
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, storage: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, storage: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
            {/* box 5*/}

            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Battery Life
              </label>
              <input
                type="text"
                name="name"
                placeholder="Battery Life"
                value={
                  variationData[currentPos]?.battery_life
                    ? variationData[currentPos]?.battery_life
                    : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].battery_life
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, battery_life: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, battery_life: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Box Status
              </label>

              <select
                name="box_status"
                id="box_status"
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
                value={
                  (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData?.[orderIndex]?.product_imei?.[0]?.box_status || ""
                    : variationData?.[currentPos]?.box_status || ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, box_status: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, box_status: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
              >
                <option value="">Select</option>
                <option value="with box">With Box</option>
                <option value="without box">Without Box</option>
              </select>
            </div>

            {/* box 6*/}

            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                Note
              </label>
              <input
                type="text"
                name="name"
                placeholder="Note"
                value={
                  variationData[currentPos]?.note
                    ? variationData[currentPos]?.note
                    : (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                    ? variationData[(typePurchase || selectedItem?.onExchange) ? orderIndex : currentPos]
                        ?.product_imei[0].note
                    : ""
                }
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange)) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, note: e.target.value }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) => {
                      return index === currentPos
                        ? { ...item, note: e.target.value }
                        : item;
                    });
                  }

                  seteVariationData(updatedVariationData);
                }}
                className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
              />
            </div>

            {/* box 7*/}

              <div className="w-full relative">
                <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                  Upload Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const formData = new FormData();
                    formData.append("file_name", file);

                    try {
                      console.log("Inside............ ")
                      const response = await axios.post(
                        `${process.env.REACT_APP_API_URL}file-upload`,
                        formData,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`, // replace with actual token
                            "Content-Type": "multipart/form-data",
                          },
                        }
                      );
                      const data = response.data;
                      console.log("Data............ ", data)
                      if (data.success) {
                        const imagePath = data.path;

                        let updatedVariationData;

                        if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                          updatedVariationData = variationData?.map(
                            (item, index) => {
                              if (index === orderIndex) {
                                return {
                                  ...item,
                                  product_imei: item.product_imei?.map(
                                    (imei, i) =>
                                      i === 0
                                        ? { ...imei, image_path: imagePath }
                                        : imei
                                  ),
                                };
                              }
                              return item;
                            }
                          );
                        } else {
                          updatedVariationData = variationData?.map(
                            (item, index) => {
                              return index === currentPos
                              ? { ...item, image_path: imagePath }
                              : item;
                            }
                          );
                        }

                        seteVariationData(updatedVariationData);
                      } else {
                        alert("Upload failed: " + data.message);
                      }
                    } catch (error) {
                      console.error("Upload error", error);
                      if (error.response) {
                        console.error("Server responded with an error:", error.response.data);
                      } else {
                        console.error("Network error or no response received", error.message);
                      }
                      alert("Something went wrong during upload");
                    }
                  }}
                  className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
                />
              </div>
              <div className="w-full relative">
                <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                  Product Condition
                </label>
                <select
                    name="product_condition"
                    id="product_condition"
                    className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
                    value={
                      (typePurchase || selectedItem?.onExchange) && typeSaleEdit
                        ? variationData?.[orderIndex]?.product_imei?.[0]?.product_condition || ""
                        : variationData?.[currentPos]?.product_condition || ""
                    }
                    onChange={(e) => {
                      let updatedVariationData;

                      if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                        updatedVariationData = variationData?.map((item, index) => {
                          if (index === orderIndex) {
                            return {
                              ...item,
                              product_imei: item.product_imei?.map((imei, i) =>
                                i === 0
                                  ? { ...imei, product_condition: e.target.value }
                                  : imei
                              ),
                            };
                          }
                          return item;
                        });
                      } else {
                        updatedVariationData = variationData?.map((item, index) => {
                          return index === currentPos
                            ? { ...item, product_condition: e.target.value }
                            : item;
                        });
                      }

                      seteVariationData(updatedVariationData);
                    }}
                >
                  <option selected value="">Select </option>
                  <option value="intact">Intact</option>
                  <option value="used">Used</option>
                  <option value="damaged">Damaged</option>
                  <option value="service">Service</option>
                  <option value="client">Client</option>
                  <option value="phone">Phone</option>
                  <option value="gadget">Gadget</option>
                </select>
              </div>

            {/* box 8*/}
            <div className="w-full relative">
              <div className="p-4">
                <ChromePicker color={resolveColor()} onChange={(color) => handleChange(color)} />

                <input
                  type="text"
                  value={resolveColor()}
                  onChange={handleInputChange}
                  className="mt-4 border px-2 py-1 rounded"
                />
              </div>
            </div>

            {/* box-9 */}

            <div className="flex items-start justify-center gap-2 w-full relative">
              <input
                type="checkbox"
                value="1"
                name="is_ecommerce"
                className="w-5 h-5 rounded-[6px] accent-blue-600"
                onChange={(e) => {
                  let updatedVariationData;

                  if ((typePurchase || selectedItem?.onExchange) && typeSaleEdit) {
                    updatedVariationData = variationData?.map((item, index) => {
                      if (index === orderIndex) {
                        return {
                          ...item,
                          product_imei: item.product_imei?.map((imei, i) =>
                            i === 0
                              ? { ...imei, is_ecommerce: e.target.checked ? 1 : 0 }
                              : imei
                          ),
                        };
                      }
                      return item;
                    });
                  } else {
                    updatedVariationData = variationData?.map((item, index) =>
                      index === currentPos
                        ? { ...item, is_ecommerce: e.target.checked ? 1 : 0 }
                        : item
                    );
                  }

                  seteVariationData(updatedVariationData);
                }}
              />

              <p className="text-[#2c2c2d] text-sm select-none">
                Ecommerce
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <div>
        <label
          htmlFor={formId}
          onClick={handleSubmit}
          className="cursor-pointer w-full bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-semibold text-lg"
        >Save
        </label>
      </div> */}
    </div>
  );
};

export default ProductVariationForm;
